export enum ActivityDrawerLocation {
    OVERVIEW = 'overview',
    DETAILS = 'details',
    ACTIVITIES = 'activities',
  }

export enum ActivityDrawerState {
    CREATE = 'create',
    EDIT = 'edit',
  }

export enum ActivityDrawerTab {
    ACTIVITY = 'activity',
    MESSAGES = 'messages',
    STUDENTS = 'students',
    STUDENT = 'student',
  }
